function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var ContributionsApiService = /*#__PURE__*/function () {
  function ContributionsApiService() {
    _classCallCheck(this, ContributionsApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(ContributionsApiService, [{
    key: "GetMyContributions",
    value: function GetMyContributions() {
      var url = "".concat(this._appRoot, "/Api/ContributionsApi/MyContributionStatement");
      return Ajax.Get(url);
    }
  }, {
    key: "SetStatementMethod",
    value: function SetStatementMethod(goPaperless) {
      var url = "".concat(this._appRoot, "/Api/ContributionsApi/SetStatementMethod?goPaperless=").concat(goPaperless);
      return Ajax.Get(url);
    }
  }]);

  return ContributionsApiService;
}();